export default __webpack_public_path__ + "static/media/confrence.22269a10.svg";